<template>
  <div class="c-product-card">
    <a
      :href="model.url"
      :target="model.openInNewWindow ? '_blank' : '_self'"
      :rel="model.openInNewWindow ? 'noopener noreferrer' : ''"
      class="item-link"
      @click="$emit('itemClick', { hitId: model.hitId, index: index + 1 })"
    >
      <Picture
        v-if="model.image"
        v-bind="model.image"
        class="item-picture relative block h-0 pt-full rounded"
        img-class="absolute top-0 left-0 w-full h-full object-cover p-6 transition-transform duration-150 ease-out"
        :mobile="mobile"
        :alt="model.name"
        :width="width"
        :height="height"
      />

      <div class="relative text-center mt-8 mb-4 flex-grow">
        <span class="text-sm font-light md:font-normal md:text-lg">{{ model.name }}</span>
      </div>
      <span
        v-if="model.isNew"
        class="c-splash-sign"
      >
        <span>{{ model.newLabel }}</span>
      </span>
    </a>
    <AdimoButton
      v-if="model.adimoButton"
      :model="model.adimoButton"
    />
  </div>
</template>

<script>
import Picture from '@/components/Picture.vue'
import AdimoButton from '@/components/AdimoButton.vue'

export default {
  components: {
    AdimoButton,
    Picture
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    mobile: {
      type: Array,
      default: () => [300, 300]
    },
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    }
  }
}
</script>
